import { FC } from "react";
import { IResolveFATServiceOrderFormSchema } from "./schema";
import moment from "moment";

const TestInfoSummary: FC<{ data: IResolveFATServiceOrderFormSchema["testInfo"], values: IResolveFATServiceOrderFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>
      <span className="text-xs font-light">Main Test Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Project Name
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.projectName || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Number Of Supplier Representatives
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.numberOfSupplierReps || "0"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Number Of ECG Representatives
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.numberOfECGReps || "0"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Area Of Deployment
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.areaOfDeployment || "N/A"}
          </div>
        </div>
        <div className="col-span-2">
          <span className="block text-sm font-light text-gray-700">
            Residential Address
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.areaOfDeployment || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            GhanaPost Address
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.ghanaPostAddress || "N/A"}
          </div>
        </div>
      </div>
    </div>
    <div className='pt-6'>
      <span className="text-xs font-light">Timeline Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div>
          <span className="block text-sm font-light text-gray-700">
            FAT Start Date
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {moment(data?.fatStartDate).format("DD/MM/YYYY") || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            FAT End Date
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {moment(data?.fatToDate).format("DD/MM/YYYY") || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            FAT Duration
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {moment(data?.fatToDate).diff(moment(data?.fatStartDate))} Days
          </div>
        </div>
      </div>
    </div>
    <div className='pt-6'>
      <span className="text-xs font-light">ECG Representatives Information</span>
      <div className={"flex flex-col"}> 
        {
          data?.representatives?.map((rep, idx) => (
            <div className={"border-b border-gray-300 py-6"} key={idx}>
              <span className="text-xs font-light">Representative #{idx + 1} Information</span>
              <div className='grid grid-cols-2 gap-6'>
                <div className="col-span-1">
                  <span className="block text-sm font-light text-gray-700">
                    Representative Name
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    {rep?.fullName || "N/A"}
                  </div>
                </div>
                <div className="col-span-1">
                  <span className="block text-sm font-light text-gray-700">
                    Designation
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    {rep?.designation || "N/A"}
                  </div>
                </div>
                <div className="col-span-1">
                  <span className="block text-sm font-light text-gray-700">
                    Phone Number
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    {rep?.phoneNumber || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  </div>
);

export default TestInfoSummary;